import { render, staticRenderFns } from "./RDV.vue?vue&type=template&id=2a722495"
import script from "./RDV.vue?vue&type=script&lang=js"
export * from "./RDV.vue?vue&type=script&lang=js"
import style0 from "./RDV.vue?vue&type=style&index=0&id=2a722495&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports